import React, { useState, useMemo } from "react";
import "./FDReport.css";

const accountsData = [
    // FD/MIS
  {
    sn: 1,
    status: "Active",
    mainType: "FD",
    name: "Rajesh Singh",
    guardian: "Suresh Singh",
    mobile: "9876541110",
    aadhar: "111122223333",
    approvalDate: "2023-02-01",
    lastTransaction: "2023-08-10",
    approvedBy: "Manager C",
    balance: "₹50,000",
    email: "rajesh@example.com",
    nominee: "Rita Singh",
    setENach: "Yes",
    nextDue: "2023-09-10",
  },
  {
    sn: 2,
    status: "Pre-Closed",
    mainType: "MIS",
    name: "Priya Sharma",
    guardian: "Sunil Sharma",
    mobile: "9123456781",
    aadhar: "444455556666",
    approvalDate: "2022-05-20",
    lastTransaction: "2023-02-15",
    approvedBy: "Manager D",
    balance: "₹25,000",
    email: "priya@example.com",
    nominee: "Sonia Sharma",
    setENach: "No",
    nextDue: "2023-03-20",
  },
];
const mainTabsFD = ["FD Report", "MIS Report"];
const secondaryTabs = ["All", "Active", "Closed", "Pre-Closed", "Reject"];
const rowsPerPage = 2;

const ReportWithTabs = () => {
  // FD/MIS state
  const [activeMainTabFD, setActiveMainTabFD] = useState("FD Report");
  const [activeSecondaryFD, setActiveSecondaryFD] = useState("All");
  const [currentPageFD, setCurrentPageFD] = useState(1);
  const [searchQueryFD, setSearchQueryFD] = useState("");
  const [selectedRowFD, setSelectedRowFD] = useState(null);

 // FD/MIS filtered data
  const filteredDataFD = useMemo(() => {
    let data = accountsData.filter(
      (item) =>
        item.mainType === (activeMainTabFD === "FD Report" ? "FD" : "MIS")
    );
    if (activeSecondaryFD !== "All") {
      data = data.filter((item) => item.status === activeSecondaryFD);
    }
    if (searchQueryFD.trim()) {
      data = data.filter((item) =>
        Object.values(item)
          .map((val) => (val ? val.toString() : ""))
          .join(" ")
          .toLowerCase()
          .includes(searchQueryFD.toLowerCase())
      );
    }
    return data;
  }, [activeMainTabFD, activeSecondaryFD, searchQueryFD]);

  const paginatedDataFD = filteredDataFD.slice(
    (currentPageFD - 1) * rowsPerPage,
    currentPageFD * rowsPerPage
  );
  const totalPagesFD = Math.ceil(filteredDataFD.length / rowsPerPage);

  // Handlers
  const handleMainTabChangeFD = (tab) => {
    setActiveMainTabFD(tab);
    setActiveSecondaryFD("All");
    setCurrentPageFD(1);
    setSelectedRowFD(null);
  };
  const handleSecondaryChangeFD = (tab) => {
    setActiveSecondaryFD(tab);
    setCurrentPageFD(1);
    setSelectedRowFD(null);
  };
  // FD/MIS Table
  const renderTableFDMIS = (data, activeSec, setSelectedRowFn) => (
    <table className="DDFDReport-table">
      <thead>
        <tr>
          <th>SN</th>
          <th>Account</th>
          <th>Name</th>
          <th>Mobile</th>
          {activeSec === "All" && (
            <>
          <th>Status</th>
          <th>Guardian</th>
          <th>Aadhar</th>
          <th>Approval Date</th>
          {/* <th>Approved By</th> */}
          <th>Share</th>
          <th>Deposit Bond</th>
          </>
          )}
          {activeSec !== "All" && <th>View</th>}
        </tr>
      </thead>
      <tbody>
        {data.length > 0 ? (
          data.map((item) => (
            <tr key={item.sn}>
              <td>{item.sn}</td>
              <td>{item.mainType}</td>
              <td>{item.name}</td>
              <td>{item.mobile}</td>
              {activeSec === "All" ? (
                <>
              <td>{item.status}</td>
              <td>{item.guardian}</td>
              <td>{item.aadhar}</td>
              <td>{item.approvalDate}</td>
              {/* <td>{item.approvedBy}</td> */}
              <td style={{ textAlign: "center" }}>
                  <button
                    className="FDsharecerti-sub"
                    onClick={() =>
                      alert(`Generating Share Certificate for ${item.name}`)
                    }
                  >
                     Certificate
                  </button>
                </td>
                
                <td style={{ textAlign: "center" }}>
                  <button
                    className="FDBond-sub"
                    onClick={() =>
                      alert(`Generating Deposit Bond Certificate for ${item.name}`)
                    }
                  >
                     Certificate
                  </button>
                </td>
              </>
              ) : (
                <td>
                  <button
                    className="DDFDReportview-btn"
                    onClick={() => setSelectedRowFn(item)}
                  >
                    View
                  </button>
                </td>
              )}
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="10" style={{ textAlign: "center" }}>No Data Found</td>
          </tr>
        )}
      </tbody>
    </table>
  );

  // PDF Render
  const renderPDF = (selected, type) => (
    selected && (
      <div className="DDFDReportpdf-style-card">
        <h3>Report Details</h3>
        <table className="DDFDReportpdf-style-table">
          <tbody>
            <tr>
              <td><strong>SN</strong></td>
              <td>{selected.sn}</td>
              {type === "FD" && (
                <>
                  <td><strong>Account</strong></td>
                  <td>{selected.mainType}</td>
                </>
              )}
            </tr>
            <tr>
              <td><strong>Status</strong></td>
              <td>{selected.status}</td>
              <td><strong>Name</strong></td>
              <td>{selected.name}</td>
            </tr>
            <tr>
              <td><strong>Guardian</strong></td>
              <td>{selected.guardian}</td>
              <td><strong>Mobile</strong></td>
              <td>{selected.mobile}</td>
            </tr>
            <tr>
              <td><strong>Aadhar</strong></td>
              <td>{selected.aadhar}</td>
              <td><strong>Approval Date</strong></td>
              <td>{selected.approvalDate}</td>
            </tr>
            <tr>
              <td><strong>Approved By</strong></td>
              <td>{selected.approvedBy}</td>
              {type === "RD" && (
                <>
                  <td><strong>Next Due</strong></td>
                  <td>{selected.nextDue}</td>
                </>
              )}
            </tr>
          </tbody>
        </table>
      </div>
    )
  );
   return (
    <div>
    <div className="DDFDReport-containers fd-mis-container">
        <div className={`DDFDReport-main-tabs ${activeMainTabFD.includes("FD") ? "FD" : "MIS"}`}>
          {mainTabsFD.map((tab) => (
            <button
              key={tab}
              className={`DDFDReport-main-btn ${activeMainTabFD === tab ? "active" : ""}`}
              onClick={() => handleMainTabChangeFD(tab)}
            >
              {tab}
            </button>
          ))}
        </div>
        <div className={`DDFDReport-secondary-tabs ${activeMainTabFD.includes("FD") ? "FD" : "MIS"}`}>
          {secondaryTabs.map((tab) => (
            <button
              key={tab}
              className={`DDFDReport-secondary-btn ${activeSecondaryFD === tab ? "active" : ""}`}
              onClick={() => handleSecondaryChangeFD(tab)}
            >
              {tab}
            </button>
          ))}
        </div>
        <div className="DDFDReportsearch-box">
          <input
            type="text"
            placeholder="Search by any field..."
            value={searchQueryFD}
            onChange={(e) => {
              setSearchQueryFD(e.target.value);
              setCurrentPageFD(1);
            }}
          />
        </div>
        <div className="DDFDReporttable-container">
          {renderTableFDMIS(paginatedDataFD, activeSecondaryFD, setSelectedRowFD)}
        </div>
        <div className="DDFDReportpagination">
          <button onClick={() => setCurrentPageFD((p) => p - 1)} disabled={currentPageFD === 1}>Previous</button>
          <span>Page {currentPageFD} of {totalPagesFD || 1}</span>
          <button onClick={() => setCurrentPageFD((p) => p + 1)} disabled={currentPageFD === totalPagesFD || totalPagesFD === 0}>Next</button>
        </div>
        {renderPDF(selectedRowFD, "FD")}
      </div>
    </div>
  );
};

export default ReportWithTabs;
